/* eslint-disable @typescript-eslint/camelcase */
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { Component, Vue, Watch } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import AppFormTable from '@core/components/AppFormTable.vue'
import LoadingSpinner from '@core/components/LoadingSpinner.vue'
import AppDatatable from '@core/components/AppDatatable.vue'
import AppModal from '@core/components/AppModalV2.vue'
import { IDateService } from '@master/services/IDateService'
import { FormBase } from '@core/model/recruit/FormBase'
import { AllForms } from '@core/model/recruit/AllForms'
import { namespace } from 'vuex-class'
import { IProjectInfo } from '@master/config/IProjectInfo'

const recruitFormStore = namespace('RecruitFormStore')
@Component({
  components: {
    AppForm,
    AppFormTable,
    AppDatatable,
    LoadingSpinner,
    AppModal
  }
})
export class FormBaseMixin extends Vue {
  @inject()
  protected dateService: IDateService

  @inject()
  protected projectInfo: IProjectInfo

  @inject()
  protected $api: API

  @recruitFormStore.State
  private forms: AllForms

  @recruitFormStore.Mutation
  private setForms

  protected type = null
  protected allForms: AllForms = new AllForms()
  protected loading = false
  protected showError = false
  protected recruitDetails = null

  get formData (): FormBase {
    return this.forms.getForm(this.type)
  }

  get formDataErrors () {
    return this.formData.error
  }

  get recruitAccountOid () {
    return this.$router.currentRoute.params.recruitAccountOid
  }

  get formName () {
    return this.$router.currentRoute.name
  }

  get formConfig () {
    return this.allForms.configs.find(form => form.name === this.formName)
  }

  get formType () {
    return this.formConfig?.type
  }

  get currentUser () {
    return this.$store.getters.currentUser
  }

  @Watch('showError')
  focusError (se) {
    if (!se) return
    if (!this.formDataErrors || !this.formDataErrors.length) return
    const first = this.formDataErrors[0]
    const ele = document.getElementById(first.key)
    if (!ele) return
    ele.scrollIntoView({ behavior: 'smooth' })
  }

  save () {
    // cannot save if already signed
    // if (this.formData.signed) return
    this.loading = true
    this.$api.forms.update(this.formData).then((res) => {
      if (res && res.error) return alert(res.error)
      this.setForms([res])
    }).finally(() => {
      this.loading = false
    })
  }
}
